import { z } from 'zod';
import superjson from 'superjson';
import { ThemeTokens } from './create_POST.schema';

export const schema = z.object({
  sessionId: z.string().optional(), // Optional for global themes
  prompt: z.string().min(5).max(1000),
});

export type InputType = z.infer<typeof schema>;

export type GeneratedTheme = {
  name: string;
  description: string;
  tokens: ThemeTokens;
  darkTokens?: ThemeTokens;
  imagePrompt?: string;
};

export type OutputType = {
  theme: GeneratedTheme;
};

export const generateTheme = async (input: InputType, init?: RequestInit): Promise<OutputType> => {
  const result = await fetch('/_api/themes/generate', {
    method: 'POST',
    credentials: 'include',
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...(init?.headers ?? {}),
    },
    body: superjson.stringify(input),
  });
  const text = await result.text();
  if (!result.ok) {
    let errorMsg = 'Failed to generate theme';
    try {
      const parsed = superjson.parse<{ error: string }>(text);
      errorMsg = parsed?.error || errorMsg;
    } catch {
      try {
        const parsed = JSON.parse(text) as { error?: string };
        errorMsg = parsed?.error || text || errorMsg;
      } catch {
        errorMsg = text || errorMsg;
      }
    }
    throw new Error(errorMsg);
  }
  try {
    return superjson.parse<OutputType>(text);
  } catch {
    return JSON.parse(text) as OutputType;
  }
};
